import {CodeViewHeader} from '@github-ui/code-view-header'
import type {HeaderResponse} from '@github-ui/code-view-header/types'
import {CodeViewBannersProvider} from '@github-ui/code-view-shared/contexts/CodeViewBannersContext'
import type {DataRouterFileOverviewPayload} from '@github-ui/code-view-types'
import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {useMemo} from 'react'

import {HeaderBanners} from '../CodeViewBanners'
import {extractOverviewFilesData} from './OverviewSidebar'

export interface MergedHeaderPayload {
  aboutData: HeaderResponse | undefined
  queryKey: readonly unknown[]
}

export interface OverviewHeaderProps {
  overview: Partial<Pick<DataRouterFileOverviewPayload['overview'], 'overviewFiles' | 'codeButton'>>
  headerData: MergedHeaderPayload
}

export function OverviewHeader({overview, headerData}: OverviewHeaderProps) {
  const overviewFiles = useMemo(() => extractOverviewFilesData(overview), [overview])
  const {aboutData} = headerData

  if (!aboutData) {
    return null
  }

  return (
    <ErrorBoundary boundaryName="overview-header">
      <CodeViewBannersProvider>
        <HeaderBanners />
        <CodeViewHeader
          {...aboutData}
          {...(overviewFiles ?? {})}
          hasAccessToCodespaces={overview.codeButton?.hasAccessToCodespaces ?? false}
        />
      </CodeViewBannersProvider>
    </ErrorBoundary>
  )
}
